import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from "../../_services/api.integration";
import { ActivatedRoute, Router } from "@angular/router";
import { HttpErrorResponse, HttpHeaders, HttpClient } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { User } from "../../_models/user";
import * as _ from "lodash";
import { Globals } from "../../_models/globals";
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
@Component({
  selector: 'app-edit-user-account',
  templateUrl: './edit-user-account.component.html',
  styleUrls: ['./edit-user-account.component.css']
})
export class EditUserAccountComponent implements OnInit {
  edituser: any = [];
  auth: any;
  groupList: any;
  securityConfig: any;
  role = {
    name: "",
  };

  selectedRole = {
    userRole: "",
  };
  selectedRoles = [];

  statusText1: string;
  statusText2: string;
  statusText3: string;
  statusText4: string;
  request: any = [];

  constructor(private alertService: AlertService, private api: ApiIntegration, private http: HttpClient, private route: ActivatedRoute, private router: Router, private user: User, public g: Globals) {
    this.g.page = "Edit User Account";
    //this.getAllActiveSecurityType();
    this.api.getOwnerUserById(this.route.snapshot.params['id']).subscribe((data: any = []) => {
      this.edituser = data;
      //this.getAllSecurityConfigByUserId(this.edituser.jhiUserId);
      this.selectedRoles = _.cloneDeep(this.edituser.usersRoles);
    }, err => {
      this.alertService.error('Error', err);
    });
    if (this.user.role !== 'ACCOUNT_OWNER') {
      this.api.getUserAuthorities().subscribe((data: any) => {
        this.auth = data;
      }, err => {
        this.alertService.error('Error', err);
      });
    }
  }
  getAllSecurityConfigByUserId(jhiUserId) {
    this.api.getAllSecurityConfigByUserId(jhiUserId, this.user.organizationId).subscribe((data: any) => {
      this.securityConfig = data.getAllSecurityConfigResponses;
      this.checkSecurity();
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  checkSecurity() {
    for (let i = 0; i < this.groupList.length; i++) {
      this.groupList[i].enableAll = false;
      let length = 0;
      for (let j = 0; j < this.groupList[i].securityTypes.length; j++) {
        let index = _.findIndex(this.securityConfig, { 'securityTypeId': this.groupList[i].securityTypes[j].securityTypeId });
        if (index > -1) {
          this.groupList[i].securityTypes[j].status = 'ACTIVE';
          this.groupList[i].securityTypes[j].enabled = true;
          length = length + 1;
        } else {
          this.groupList[i].securityTypes[j].status = 'IN_ACTIVE';
          this.groupList[i].securityTypes[j].enabled = false;
        }
      }
      if (length === (this.groupList[i] || {}).securityTypes.length) {
        this.groupList[i].enableAll = true;
      }
    }
  }
  allStatusChange(role) {
    if (role.enableAll && role.securityTypes.length) {
      for (let i = 0; i < role.securityTypes.length; i++) {
        if (!role.securityTypes[i].enabled) {
          role.securityTypes[i].enabled = true;
          this.statusChange(role.securityTypes[i]);
        }
      }
    } else {
      for (let j = 0; j < role.securityTypes.length; j++) {
        if (role.securityTypes[j].enabled) {
          role.securityTypes[j].enabled = false;
          this.statusChange(role.securityTypes[j]);
        }
      }
    }
  }

  sliceUPto(num) {
    if (num) {
      if (num % 2 == 0) {
        return num / 2;
      } else {
        return (num + 1) / 2;
      }
    } else {
      return 0;
    }
  }
  statusChange(action, role: any = {}, i = '') {
    if (action.enabled) {
      action.status = 'ACTIVE';
      if (i !== '') {
        if (!this.groupList[i]['enableAll']) {
          let x = 0;
          role.securityTypes.forEach((s) => {
            if (s.enabled) {
              x = x + 1;
            }
          });
          if (x === role.securityTypes.length) {
            this.groupList[i].enableAll = true;
          }
        }
      }
    } else {
      if (i !== '') {
        if (this.groupList[i]['enableAll']) {
          this.groupList[i].enableAll = false;
        }
      }
      action.status = 'IN_ACTIVE';
    }

    this.changeStatus(action)
  }
  changeStatus(action) {
    this.g.loaderDisplay = "display";
    this.request = [{
      "accessStatus": action.enabled ? 'GRANTED' : 'REVOKED',
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": 1,
      "securityTypeId": action.securityTypeId,
      "userId": this.edituser.jhiUserId
    }];

    let body = {
      "accountOwnerId": this.user.accountOwnerId,
      "organizationId": this.user.organizationId,
      "createAppSecurityConfigRequestList": this.request
    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + (action.enabled ? ('api/createSecurityConfig') : ('api/revokeSecurityConfig')), body,
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.alertService.success('User', 'Status Changed Successfully');
        }
        else {
          this.alertService.error('Error', data['message']);
        }
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
  click() {
    if (this.role.name != "") {
      this.selectedRole.userRole = this.role.name;
      this.selectedRoles.push(_.cloneDeep(this.selectedRole));
      this.role.name = "";
    }
  }

  removeProduct(rp) {
    let index = this.selectedRoles.indexOf(rp);
    this.selectedRoles.splice(index, 1);
  }



  getAllActiveSecurityType() {
    this.api.getAllActiveSecurityType("1").subscribe((data: any) => {
      this.groupList = data;
    }, err => { this.alertService.error('Error', err); });
  }


  ngOnInit() {
  }
  typeFirstName() {
    this.statusText1 = "";
    if (this.edituser.firstName == '' || this.edituser.firstName === null || this.edituser.firstName === undefined || this.edituser.firstName === 'undefined') {
      this.statusText1 = 'Please enter first name';
    }
  }
  typeLastName() {
    this.statusText2 = "";
    if (this.edituser.lastName == '' || this.edituser.lastName === null || this.edituser.lastName === undefined || this.edituser.lastName === 'undefined') {
      this.statusText2 = 'Please enter last name';
    }
  }
  typeMobile() {
    this.statusText3 = "";
    if (this.edituser.mobile == '' || this.edituser.mobile === null || this.edituser.mobile === undefined || this.edituser.mobile === 'undefined') {
      this.statusText3 = 'Please enter phone number';
    } else if (this.edituser.mobile.length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
    }
  }
  typeEmail() {
    this.statusText4 = "";
    if (this.edituser.email == '' || this.edituser.email === null || this.edituser.email === undefined || this.edituser.email === 'undefined') {
      this.statusText4 = 'Please enter email address';
    }
  }

  editUser() {
    this.g.loaderDisplay = "display";
    this.statusText1 = "";
    this.statusText2 = "";
    this.statusText3 = "";
    this.statusText4 = "";

    if (this.edituser.firstName == '' || this.edituser.firstName === null || this.edituser.firstName === undefined || this.edituser.firstName === 'undefined') {
      this.statusText1 = 'Please enter first name';
    }
    if (this.edituser.lastName == '' || this.edituser.lastName === null || this.edituser.lastName === undefined || this.edituser.lastName === 'undefined') {
      this.statusText2 = 'Please enter last name';
    }
    if (this.edituser.mobile == '' || this.edituser.mobile === null || this.edituser.mobile === undefined || this.edituser.mobile === 'undefined') {
      this.statusText3 = 'Please enter phone number';
    } else if ((this.edituser.mobile).toString().length != 10) {
      this.statusText3 = 'phone number must be minimum 10 characters';
    }
    if (this.edituser.email == '' || this.edituser.email === null || this.edituser.email === undefined || this.edituser.email === 'undefined') {
      this.statusText4 = 'Please enter email address';
    }

    if (this.statusText1 != "" || this.statusText2 != "" || this.statusText3 || this.statusText4 != "") {
      this.g.loaderDisplay = "";
      return false;
    }
    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));

    this.http.post(environment.apiUrl + 'api/editOwnerUsers', {

      "accountOwnerId": this.user.accountOwnerId,
      "email": this.edituser.email,
      "firstName": this.edituser.firstName,
      "id": this.route.snapshot.params['id'],
      "lastName": this.edituser.lastName,
      "mobile": this.edituser.mobile,
      "organizationId": "1",
      "status": "ACTIVE",
      //"usersRoles": this.selectedRoles
    },
      { headers: header1 }).subscribe(data => {
        this.g.loaderDisplay = "";
        if (data['code'] == 200) {
          this.g.loaderDisplay = "";
          this.alertService.success('User', 'Edited Successfully');
          this.g.pageTab = 'manageUsers';
          this.router.navigate(['/admin/myAccountList']);
        }
        else {
          this.alertService.error('Error', data['message']);
        }
        //this.tabClicked === 'manageUsers'
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";
        });
  }
}
